import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Accounts} from '../accounts';
import {AccountsService} from '../accounts.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TreeNode} from 'primeng/api';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TreeModule} from "primeng/tree";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {stringify} from "@angular/compiler/src/util";
import {Item} from "../../../../model";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {CurrencyMaskModule} from "ng2-currency-mask";

@NgModule({
    imports: [CommonModule, FormsModule, TreeModule, DropdownModule,MessagesModule,MyInputsModule,CurrencyMaskModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        AccountsShowComponent
    ],
    entryComponents: [
        AccountsShowComponent
    ],
    exports: [],
    providers: [SharedService, AccountsService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-accounts-show',
    templateUrl: './accounts-show.component.html',
    styleUrls: ['./accounts-show.component.scss'],
    providers: [AccountsService, ConfirmationService, MessageService]
})

export class AccountsShowComponent implements OnInit, AfterViewInit {
    id: string;
    accounts = new Accounts();
    applog: AppLogComponent;
    @Input() delId;
    @Input() scrId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() newDatad;

    @Input() modelName;
    @Input() allow2action = true;

    modalRef: NgbModalRef;
    parent:any;
    form: FormGroup;
    group: any[] = [];
    tree: TreeNode[];
    item: Item;

    name: string;
    private sub: any;
    msgs: Message[] = [];
  Classification_account_arr: any[] =[
    {'val':1,'title':'Customers'},{'val':2,'title':'Suppliers'},{'val':3,'title':'Expenses'},{'val':4,'title':'Revenues'},{'val':5,'title':'Depreciation'},
    {'val':6,'title':'Banks'},{'val':7,'title':'Fund'},{'val':8,'title':'Cash customer'},{'val':9,'title':'Cash supply'},{'val':10,'title':'Employee'},
    {'val':11,'title':'Sales'},{'val':12,'title':'Sales returns'},{'val':13,'title':'Purchases'},{'val':14,'title':'Purchases returns'},{'val':15,'title':'VAT'},
    {'val':16,'title':'Taxes'},{'val':17,'title':'fixed assets'},{'val':18,'title':'Complex consumption'},{'val':19,'title':'cyclical revenues'}
  ];

  account_nature_arr: any[] = [
    {'val':1,'title':'Debt'},{'val':2,'title':'Credit'},{'val':3,'title':'Both'}
  ];
  final_account_arr: any[] = [
    {'val':1,'title':'Budget'},{'val':2,'title':'Profit and loss'},{'val':3,'title':'Trade'}
  ];
    private _saveButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private accountsService: AccountsService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private modalService: NgbModal,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(AccountsShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},


        ]);
        this.sharedservice.setModelName('accounts');

    }
    showParent() {
        if(this.parent) {

            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log('before dismiss');
                    return true;
                }
            };
            this.modalRef = this.modalService.open(AccountsShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.accounts;
        modalRef.componentInstance.rowId = '';

    }
    ngAfterViewInit() {
        if(!this.scrId && !this.newData) {

            this._saveButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if (this._saveButton) {
                this._saveButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/accounts/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteAccounts(this.accounts);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/accounts']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/accounts/search']);
                });
            }
        }
    }

    ngOnInit() {
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      };

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
        }
      });

      const msg = JSON.parse(localStorage.getItem('showMessages'));
      if (msg) {
        localStorage.removeItem('showMessages');
        this.msgs = msg;
      }
        this.accountsService.getAllAccounts().subscribe(
            group => {
                this.group = group;
            });
        this.accountsService.getTree('0').then(tree => this.tree = tree);
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}, Validators.required),
          name: new FormControl({value: '', disabled: true}, [Validators.required]),
          master_account_id: new FormControl({value: '', disabled: true}),
          account_nature: new FormControl({value: '', disabled: true}, Validators.required),
          Classification_account: new FormControl({value: '', disabled: true}, Validators.required),
          sub_account_expected: new FormControl({value: '', disabled: true}, Validators.required),
          max_credit: new FormControl({value: '', disabled: true}, Validators.required),
          max_debit: new FormControl({value: '', disabled: true}, Validators.required),
          final_account: new FormControl({value: '', disabled: true}, Validators.required)

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;

            this.delId = false;
            localStorage.removeItem('filter');
          localStorage.removeItem('summ');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.accountsService.getById(this.id).subscribe(
                accounts => {
                    this.id = accounts.id;
                    this.accounts = accounts;
                    this.parent = accounts.p_group_id;
                    this.form.patchValue({
                        id: accounts.id,
                        name: accounts.name,
                      master_account_id: accounts.master_account_id,
                      account_nature: accounts.account_nature,
                      Classification_account: accounts.Classification_account,
                      sub_account_expected: accounts.sub_account_expected,
                      final_account: accounts.final_account,
                      max_credit: accounts.max_credit,
                      max_debit: accounts.max_debit,
                    });

                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {
            //this.activeModal.dismiss('');

            this.oldData = false;
            this.newData = false;

            this.delId = false;

            this.accountsService.getById(this.scrId).subscribe(
                accounts => {
                    this.id = accounts.id;
                    this.accounts = accounts;
                    this.form.patchValue({
                        id: accounts.id,
                      name: accounts.name,
                      master_account_id: accounts.master_account_id,
                      account_nature: accounts.account_nature,
                      Classification_account: accounts.Classification_account,
                      sub_account_expected: accounts.sub_account_expected,
                      final_account: accounts.final_account,
                      max_credit: accounts.max_credit,
                      max_debit: accounts.max_debit,
                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.accountsService.getTrashedById(this.delId).subscribe(
                accounts => {
                    this.id = accounts.id;
                    this.accounts = accounts;
                    this.form.patchValue({
                        id: accounts.id,
                        name: accounts.name,
                      master_account_id: accounts.master_account_id,
                      account_nature: accounts.account_nature,
                      Classification_account: accounts.Classification_account,
                      sub_account_expected: accounts.sub_account_expected,
                      final_account: accounts.final_account,
                      max_credit: accounts.max_credit,
                      max_debit: accounts.max_debit,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.accounts = this.newData;
          // this.allow2action = false;
          this.newDatap = true;


          console.log(this.newDatap);
          console.log(this.newDatad);

            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
              master_account_id: this.newData.master_account_id,
              account_nature: this.newData.account_nature,
              Classification_account: this.newData.Classification_account,
              sub_account_expected: this.newData.sub_account_expected,
              final_account: this.newData.final_account,
              max_credit: this.newData.max_credit,
              max_debit: this.newData.max_debit,
            });
        }
    }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('fin.accounts.'+role) >= 0) {
            return true;
        }
        return false;
    }

    nodeSelect(_id: string) {
        this.id = _id;
        this.accountsService.getById(_id).subscribe(
            accounts => {
                this.accounts = accounts;
                this.form.patchValue({
                    id: accounts.id,
                    name: accounts.name,
                    master_account_id: accounts.master_account_id,
                    account_nature: accounts.account_nature,
                    Classification_account: accounts.Classification_account,
                    sub_account_expected: accounts.sub_account_expected,
                    final_account: accounts.final_account,
                  max_credit: accounts.max_credit,
                  max_debit: accounts.max_debit,
                  });
              }, error => {
                  console.log(error);
              }
        );
    }

    addnew(_id: string) {
        this.router.navigate(['/accounts', _id]);
    }

    deleteAccounts(accounts: Accounts) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (accounts) {
                    this.accountsService.delete(accounts.id).subscribe(
                        res => {
                          let serv = 'success';
                          let messag = 'Delete completed';
                          if(res.result){
                            serv = 'success';
                            messag = 'Delete completed';
                          }else{
                            serv = 'error';
                            messag = 'Can not delete parent account or accounts used in other screen';
                          }
                            this.msgs = [];
                            this.msgs.push({
                                severity: serv,
                                summary: '',
                                detail: this.translate.instant(messag)
                            });
                            setTimeout(()=> {
                                this.router.navigate(['/accounts']);
                            },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );
                }
            }
        });
    }

    recoverEdit(accounts: Accounts) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (accounts) {
                    this.accountsService.update(accounts).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/accounts/show', accounts.id]);
                        }
                    );
                }
            }
        });

      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      };

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
        }
      });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.accountsService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/accounts/list']);
                        }
                    );
                }
            }
        });
    }



  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = AccountsShowComponent;

    }
  }



}



// WEBPACK FOOTER //
// ./src/app/views/fin/accounts/accounts-show/accounts-show.component.ts